module.exports = __webpack_public_path__ + "img/FlashOnOutlined.ca0aaad1.svg";